// src/components/LoadingScreen.js
import React from 'react';

export default function LoadingScreen() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#EFF6FF' }}>
      <div style={{ fontSize: 56, marginBottom: 16 }}>📚</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: '#1E40AF', marginBottom: 8 }}>StudyDost</div>
      <div style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Har Student Ka AI Dost</div>
      <div style={{ width: 36, height: 36, border: '3px solid #DBEAFE', borderTopColor: '#1E40AF', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
